"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngagementChangedEventCard = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Engagement_1 = require("Common/Engagement");
var styles = __importStar(require("./Timeline.css"));
var EngagementChangedEventCard = function (_a) {
    var _b;
    var eventData = _a.eventData;
    var displayName = (0, Engagement_1.getEngagementLevelDisplayName)(eventData.engagementLevel);
    var previousDisplayName = (0, Engagement_1.getEngagementLevelDisplayName)((_b = eventData.previousLevel) !== null && _b !== void 0 ? _b : undefined);
    return (react_1.default.createElement(kaleidoscope_1.Stack, { align: "start", gap: "s" },
        react_1.default.createElement(kaleidoscope_1.Heading, { className: styles.engagementHeading, strong: true, level: "5" }, displayName),
        react_1.default.createElement(kaleidoscope_1.Text, { secondary: true, size: "xs", lineHeight: "compact" },
            "Engagement level changed from ",
            previousDisplayName,
            " to ",
            displayName)));
};
exports.EngagementChangedEventCard = EngagementChangedEventCard;
